import React, { useEffect } from 'react';
import {
    Typography,
    styled,
    Alert,
    AlertTitle,
    Slide,
    Stack,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoIcon from '@mui/icons-material/Info';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import splitCamelCaseToString from '../../utils/titleCase';

import { useSelector, useDispatch } from 'react-redux';
import { removeNotif } from '../../redux/NotificationSlice';

//error, warning, info, success

const NotificationContainer = styled(Stack)(({ theme }) => ({
    direction: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',

    position: 'fixed',
    bottom: '12px',
    left: '12px',
    margin: '0 0 10px 10px',
}));
const TitleAlert = styled(AlertTitle)({
    fontWeight: '700',
    fontSize: '18px',
    color: '#424242',
    marginTop: '0px',
    marginBottom: '0px',
});

const NotificationBar = () => {
    const dispatch = useDispatch();
    const notification = useSelector(state => state.notification.notification);
    const open = notification.filter(e => e.open === true);

    const { height } = useWindowDimensions();

    const timer = ms => new Promise(res => setTimeout(res, ms));

    useEffect(() => {
        const heightLimit = (height - 80) / 96.9;

        const load = async () => {
            for (const listOut in open) {
                if (heightLimit.toFixed() < open.length) {
                    await timer(300);
                    return deleteToast(open[listOut].id);
                }
                if (open[listOut].autoHideDuration > 0) {
                    await timer(open[listOut].autoHideDuration);
                    deleteToast(open[listOut].id);
                }
            }
        };
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notification, height]);

    const deleteToast = id => {
        dispatch(
            removeNotif({
                id: id,
            })
        );
    };

    return (
        <div>
            {notification.length !== 0 && (
                <NotificationContainer
                    spacing={2}
                    sx={{
                        zIndex: '1400',
                    }}
                >
                    {notification
                        .map((toast, idx) => {
                            let severityColor, alertIcon;
                            if (toast.severity === 'success') {
                                severityColor = '#48ce13';
                                alertIcon = (
                                    <CheckCircleIcon
                                        sx={{ fontSize: '40px' }}
                                    />
                                );
                            } else if (toast.severity === 'error') {
                                severityColor = '#f50057';
                                alertIcon = (
                                    <CancelIcon sx={{ fontSize: '40px' }} />
                                );
                            } else if (toast.severity === 'warning') {
                                severityColor = '#FF4949';
                                alertIcon = (
                                    <ErrorIcon sx={{ fontSize: '40px' }} />
                                );
                            } else if (toast.severity === 'info') {
                                severityColor = '#2979ff';
                                alertIcon = (
                                    <InfoIcon sx={{ fontSize: '40px' }} />
                                );
                            }
                            return (
                                <Slide
                                    key={idx}
                                    direction="right"
                                    in={toast.open}
                                    mountOnEnter
                                    unmountOnExit
                                >
                                    <Alert
                                        elevation={6}
                                        role="button"
                                        icon={alertIcon}
                                        onClose={() => {
                                            deleteToast(toast.id);
                                        }}
                                        closeText=""
                                        sx={{
                                            borderLeft: `10px solid ${severityColor}`,
                                            background: '#FFF',
                                            borderRadius: '8px',
                                            boxShadow: 2,
                                            width: '100%',

                                            '& .MuiAlert-icon': {
                                                color: `${severityColor}`,
                                                display: 'flex',
                                                alignItems: 'center',
                                                marginRight: '15px',
                                            },
                                            '&:hover': {
                                                boxShadow: 4,
                                            },
                                        }}
                                    >
                                        <TitleAlert>
                                            {toast.severity &&
                                                splitCamelCaseToString(
                                                    toast.severity
                                                )}
                                        </TitleAlert>
                                        <Typography
                                            variant="body1"
                                            sx={{ fontSize: '14px' }}
                                            gutterBottom
                                        >
                                            {toast.description}
                                        </Typography>
                                    </Alert>
                                </Slide>
                            );
                        })
                        .reverse()}
                </NotificationContainer>
            )}
        </div>
    );
};
export default NotificationBar;
